import {
  REPORT_CURRENCY_TYPE,
  REPORT_DECIMAL_TYPE,
  REPORT_INTEGER_TYPE,
  REPORT_NUMBER_TYPES,
} from 'Components/UI/EAReport/constants'
import { formatCurrency, formatDecimal, formatInteger } from 'Components/UI/EAReport/utils/format'

export type AlignType = 'left' | 'center' | 'right'

export interface ReportColumnSummaryInfo {
  align?: AlignType
  dataIndex?: string
  summary?: boolean
  avg?: boolean
  quantity_column?: string
  type?: string
}

export interface SummaryDataItem {
  align: AlignType
  dataIndex?: string
  total: number | null
  total_str: string
}

const sumColumnByDataIndex = (dataIndex?: string, dataSource: Record<string, unknown>[] = []): number => {
  if (!dataIndex) return 0

  return dataSource.reduce((total, record) => {
    const value = record[`${dataIndex}_num`]
    return total + (typeof value === 'number' && Number.isFinite(value) ? value : 0)
  }, 0)
}

const formatTotalByType = (total: number, type?: string): string => {
  if (type === REPORT_CURRENCY_TYPE) return formatCurrency(total)
  if (type === REPORT_DECIMAL_TYPE) return formatDecimal(total)
  if (type === REPORT_INTEGER_TYPE) return formatInteger(total)
  return '-'
}

const calculateColumnTotal = (
  column: ReportColumnSummaryInfo,
  dataSource: Record<string, unknown>[],
): { total: number | null; total_str: string } => {
  const { dataIndex, summary, avg, quantity_column, type } = column

  if ((summary === true || avg === true) && type && REPORT_NUMBER_TYPES.includes(type as never)) {
    const totalValue = sumColumnByDataIndex(dataIndex, dataSource)
    let total = totalValue

    if (avg === true && quantity_column) {
      const quantityValue = sumColumnByDataIndex(quantity_column, dataSource)
      total = quantityValue > 0 ? totalValue / quantityValue : 0
    }

    return { total, total_str: formatTotalByType(total, type) }
  }

  return { total: null, total_str: '-' }
}

const summaryReportData = (
  columns: ReportColumnSummaryInfo[] = [],
  dataSource: Record<string, unknown>[] = [],
): SummaryDataItem[] =>
  columns.map((column) => {
    const { align = 'left', dataIndex } = column
    const { total, total_str } = calculateColumnTotal(column, dataSource)

    return { align, dataIndex, total, total_str }
  })

export default summaryReportData
